import "./roadmap.css";
import { WrapperComponent, SectionTitle } from "../../../_imports";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAddressCard,
    faSearch,
    faPaperPlane,
    faRobot,
    faClipboardCheck,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";

function Roadmap() {
    const steps = [
        {
            id: 1,
            title: "Cadastre seu currículo",
            description: "Crie seu perfil profissional completo em poucos minutos.",
            icon: faAddressCard
        },
        {
            id: 2,
            title: "Escolha uma vaga",
            description: "Navegue por diversas oportunidades e encontre a ideal para você.",
            icon: faSearch
        },
        {
            id: 3,
            title: "Candidate-se",
            description: "Envie sua candidatura e uma carta de apresentação para a empresa.",
            icon: faPaperPlane
        },
        {
            id: 4,
            title: "Entrevista com TonIA",
            description: "Realize a entrevista preliminar com nossa inteligência artificial.",
            icon: faRobot
        },
        {
            id: 5,
            title: "Acompanhe o status",
            description: "Fique por dentro de cada etapa do processo seletivo em tempo real.",
            icon: faClipboardCheck
        }
    ];

    return (
        <section className="roadmap-section">
            <WrapperComponent>
                <SectionTitle text="COMO FUNCIONA?" color="green" />
                <div className="roadmap-container">
                    {steps.map((step, index) => (
                        <div key={step.id} className="roadmap-step-wrapper">
                            <div className="roadmap-card">
                                <div className="roadmap-icon-circle">
                                    <FontAwesomeIcon icon={step.icon} />
                                </div>
                                <h3 className="step-title">{step.title}</h3>
                                <p className="step-desc">{step.description}</p>
                            </div>

                            {index < steps.length - 1 && (
                                <div className="roadmap-connector">
                                    <FontAwesomeIcon icon={faChevronRight} className="connector-arrow" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </WrapperComponent>
        </section>
    );
}

export default Roadmap;
